// Single source of truth for page URLs in every language.
//
// French URLs live at the root and must never change (they already rank).
// English URLs live under /en/ with slugs chosen for US search intent.
//
// Every path ends with a slash: Netlify serves the prerendered page/index.html
// at /page/ and redirects /page to it (301). Canonical, hreflang, og:url, the
// sitemap and internal links must all use the URL that answers 200.
//
// A page is served in English only when `enLive` is true: until then its
// English route is not registered, it is left out of hreflang, of the sitemap
// and of the language switcher.

export const SITE_URL = "https://localranker.tech";

export const LANGS = ["fr", "en"];
export const DEFAULT_LANG = "fr";

export const ROUTES = {
  home: {
    fr: "/",
    en: "/en/",
    enLive: true,
  },
  gbpAudit: {
    fr: "/audit-google-my-business/",
    en: "/en/google-business-profile-audit/",
    enLive: true,
  },
  storeLocatorAudit: {
    fr: "/audit-store-locator/",
    en: "/en/store-locator-audit/",
    enLive: true,
  },
  localSerpChecker: {
    fr: "/serp-local-google/",
    en: "/en/local-serp-checker/",
    enLive: true,
  },
  reviewSentimentAnalysis: {
    fr: "/reviews-semantic-analysis/",
    en: "/en/review-sentiment-analysis/",
    enLive: true,
  },
  reviewCalculator: {
    fr: "/missing-reviews-calculator/",
    en: "/en/google-review-calculator/",
    enLive: true,
  },
  schemaGenerator: {
    fr: "/local-business-structured-data-generator/",
    en: "/en/local-business-schema-generator/",
    enLive: true,
  },
  gbpCategories: {
    fr: "/google-business-profile-categories/",
    en: "/en/google-business-profile-categories/",
    enLive: true,
  },
  // Internal tool (shown on the French home with ?access=localranker), French only.
  advancedSearch: {
    fr: "/search-extraction-google/",
    en: null,
    enLive: false,
  },
};

export const isLive = (routeId, lang) => {
  const route = ROUTES[routeId];
  if (!route || !route[lang]) return false;
  return lang === DEFAULT_LANG || route.enLive === true;
};

export const getLangFromPath = (pathname = "/") =>
  pathname === "/en" || pathname.startsWith("/en/") ? "en" : DEFAULT_LANG;

// Path of a page in a language. Falls back to that language's home when the
// page does not exist (yet) in it.
export const pathFor = (routeId, lang) =>
  isLive(routeId, lang) ? ROUTES[routeId][lang] : ROUTES.home[lang];

export const absoluteUrl = (path) => `${SITE_URL}${path}`;

const normalize = (pathname) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

export const getRouteIdFromPath = (pathname = "/") => {
  const target = normalize(pathname);
  return (
    Object.keys(ROUTES).find((id) =>
      LANGS.some((lang) => ROUTES[id][lang] && normalize(ROUTES[id][lang]) === target),
    ) || null
  );
};
